import React from "react";
import { Button } from "antd";

const ButtonComp = ({title, shape, type, ...others}) => {
  return (
    <Button type={type} shape={shape} {...others} >
      {title}
    </Button>
  );
};

export default ButtonComp;

